export const fontURL = 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:300i,400,400i,600&display=swap&subset=latin';
//# sourceMappingURL=fonts.js.map